// CONFIG SETTINGS
global.REACT_APP_ALERTS_API_URL = "#{REACT_APP_ALERTS_API_URL}";
global.REACT_APP_ENTITY_API_URL = "#{REACT_APP_ENTITY_API_URL}";
global.REACT_APP_AUTH0_DOMAIN = "#{REACT_APP_AUTH0_DOMAIN}";
global.REACT_APP_AUTH0_CLIENT_ID = "#{REACT_APP_AUTH0_CLIENT_ID}";
global.REACT_APP_AUTH0_AUDIENCE = "#{REACT_APP_AUTH0_AUDIENCE}";
